import { PLACES_GEOCODE_URL } from '../config';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Fetches GEO data for a given place ID from Google Places API.
 */
export async function fetchGeoData(params: Params) {
  const { placeId, apiKey } = params;

  const url = `${PLACES_GEOCODE_URL}?place_id=${placeId}&key=${apiKey}`;
  const response = await fetch(url);
  const data: google.maps.GeocoderResponse | undefined = await response.json();

  return data ?? FALLBACK_DATA;
}

// ─── Constants ───────────────────────────────────────────────────────────────

const FALLBACK_DATA: google.maps.GeocoderResponse = {
  results: [],
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = {
  placeId: string;
  apiKey: string;
};
